import { DATA_VERSION } from '../dataVersions';

/**
 * Get the latest dataversion number. Will return the maximum enum value
 */
export const getLatestDataVersion = () => {
  const versionNumbers = Object.keys(DATA_VERSION)
    .filter((value) => !isNaN(parseInt(value)))
    .map((res) => parseInt(res));
  return Math.max(...versionNumbers);
};
